import { Box, Stack, Typography } from '@mui/material'
import type { LucideIcon } from 'lucide-react'
import { colors } from '@/theme'

/** Icon + heading + text block used in "Why True Forge" and About values. */
export function FeatureCard({ icon: Icon, title, text }: { icon: LucideIcon; title: string; text: string }) {
  return (
    <Stack spacing={2.25}>
      <Box
        sx={{
          width: 56,
          height: 56,
          borderRadius: 2,
          display: 'grid',
          placeItems: 'center',
          color: 'primary.main',
          bgcolor: colors.surface,
          border: `1px solid ${colors.border}`,
        }}
      >
        <Icon size={26} />
      </Box>
      <Typography variant="h5" component="h3">
        {title}
      </Typography>
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        {text}
      </Typography>
    </Stack>
  )
}
